import React from "react";
import { Alert, AlertColor, Box, styled, Typography } from "@mui/material";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import { ediphiPalette } from "../../styles/colors";
import { LOADER_DO_NOT_EDIT_WARNING, LOADER_RETRY_PROMPT } from "../../constants";

/**
 * Dark-mode bar fill. The theme configures no dark palette, so the `applyStyles("dark", …)`
 * branches below never fire today — the value is kept so the component stays correct if one lands.
 */
const DARK_MODE_BAR = "#308fe8";

const StyledLinearLoader = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: ediphiPalette.info600,
    animation: "pulse 1.2s infinite ease-in-out",
    ...theme.applyStyles("dark", {
      backgroundColor: DARK_MODE_BAR,
    }),
  },
  "@keyframes pulse": {
    "0%": {
      filter: "brightness(1)",
    },
    "50%": {
      filter: "brightness(1.5)",
    },
    "100%": {
      filter: "brightness(1)",
    },
  },
}));

export interface LinearLoaderError {
  error: any;
  errorMessage: string;
  severity?: AlertColor;
}

export const getLinearLoader = (progress: number, error?: LinearLoaderError) => {
  return (
    <Box mb={1}>
      <Alert severity={error?.severity || "info"} sx={{ mb: error ? 2 : 3 }}>
        {error?.errorMessage || LOADER_DO_NOT_EDIT_WARNING}
      </Alert>
      {error ? (
        <Typography sx={{ mb: 2 }}>{LOADER_RETRY_PROMPT}</Typography>
      ) : (
        <StyledLinearLoader variant="determinate" value={progress || 3} />
      )}
    </Box>
  );
};
